module.exports = __webpack_public_path__ + "static/img/123_TO8_1668.6a5694d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/123_TO8_1668.jpg
// module id = O2PE
// module chunks = 0